module.exports = __webpack_public_path__ + "img/phone-icon.da8c45cf.svg";